import { ParkService } from 'src/app/services/park.service';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import * as $ from 'jquery';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { facilityService } from 'src/app/services/facility.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AppConstant } from 'src/app/config/app.constant';
import { SidenavService } from 'src/app/services/sidenav.service';
import { RolebasedactionService } from 'src/app/services/rolebasedaction.service';
import { MeetingService } from 'src/app/services/meeting.service';

@Component({
  standalone: false,
  selector: 'app-view-meeting-room',
  templateUrl: './view-meeting-room.component.html',
  styleUrls: ['./view-meeting-room.component.scss']
})
export class ViewMeetingRoomComponent implements OnInit {
  @ViewChild('contentActivation', { static: false }) content: ElementRef;

  data: any;
  url: any = '';
  id: any;
  facilities: any = []
  type: any;
  actProp: boolean = true;
  underMaintainance: boolean = false;
  closeResult: string;
  isLoaded: boolean = false;
  ParkId: any;
  FacilityTypeId: any;
  enableSave: boolean = false;
  fileToUpload: FormData;
  uploadForm: FormGroup;
  MeetingRoomList: any = [];
  MeetingRoomId: any;
  ImageUploadResultt: any;
  MeetingRoomListUnderMaintaince: any = [];
  meetingRoomCreate: any;
  meetingRoomRemove: any;
  meetingRoomEdit: any;
  meetingRoomView: any;
  paymentStatus: string;
  taId: string;
  totalMeetingRoomCount: string;
  maxConferenceRoom: string;
  meetingRoomName: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private apiSrvice: facilityService,
    private route: Router,
    private appStateSrv: AppStateProvider,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private parkSrv: ParkService,
    private sideNavService: SidenavService,
    private rolebasedactionService: RolebasedactionService,
    private meetingService: MeetingService,
  ) { }

  handleFileInput(event: any) {
    let formData: FormData = new FormData();
    for (let i = 0; i < event.target.files.length; i++) {
      const name = event.target.files[i].name;
      const lastDot = name.indexOf('.');
      const ext = name.substring(lastDot + 1).toLowerCase();
      console.log(ext);
      if (ext == 'png' || ext == 'jpg' || ext == 'jpeg') {
        if (event.target.files[i].name.size > 2097152) {
          return this.appStateSrv.showToast(
            'Image size must be less then 2MB'
          );
        }
        console.log("filename", event.target.files[i].name)
        formData.append("asset", event.target.files[i], event.target.files[i].name);
        this.fileToUpload = formData;
        this.uploadForm.patchValue({
          asset: event.target.files[i],
        });
        this.uploadForm.get('asset').updateValueAndValidity();

        this.apiSrvice.uploadImage(event).then((data) => {
          this.url = data;
          this.enableSave = true;
          this.appStateSrv.showToast('Image added successfully');
        });
      }
      else {
        return this.appStateSrv.showToast('Please upload a valid file in jpg/png format only');
      }
    }
  }

  loadForm() {
    this.uploadForm = this.formBuilder.group({
      asset: [''],
    });

  }

  selectedMeetingRoom() {
    this.route.navigate(['/company/create-meeting-room', this.taId]);
  }

  save() {
    const formData = new FormData();
    formData.append('Image', this.uploadForm.get('asset').value);
    formData.append('TypeId', this.id);
    this.apiSrvice.updateFaclitiesImage(formData).subscribe((res) => {
      this.ImageUploadResultt = res;
      this.route.navigate(['/facility'])
    });
  }

  ngOnInit() {

    this.activatedRoute.paramMap.subscribe(params => {
      this.taId = params.get('id'); // 'id' should match the param defined in your routes
    });

    this.meetingRoomCreate = this.rolebasedactionService.checkUserRolePermissionExits('Meeting Room:Create');
    this.meetingRoomRemove = this.rolebasedactionService.checkUserRolePermissionExits('Meeting Room:Remove');
    this.meetingRoomEdit = this.rolebasedactionService.checkUserRolePermissionExits('Meeting Room:Edit');
    this.meetingRoomView = this.rolebasedactionService.checkUserRolePermissionExits('Meeting Room:View');
    this.loadForm();
    this.type = "act"
    this.id = this.activatedRoute.snapshot.params.id;
    this.ParkId = localStorage.getItem(AppConstant.localStorage.parkId);
    this.paymentStatus = 'free';

    this.totalMeetingRoomCount = localStorage.getItem('totalMeetingRoomCount');
    this.maxConferenceRoom = localStorage.getItem('maxConferenceRoom');

    this.getMeetingRoomByPark(this.ParkId, this.paymentStatus);
  }

  getMeetingRoomByPark(ParkId, paymentStatus) {

    const parkTenantId = this.taId;
    const statusOfPayment = 'free';
    this.meetingService.getAllParkMeetingRooms(ParkId, statusOfPayment, parkTenantId).subscribe((res) => {

      if (res?.list.length > 0) {
        this.MeetingRoomList = res?.list.filter((x) => x.isUnderMaintenance == false || x.isUnderMaintenance == null);
        this.MeetingRoomListUnderMaintaince = res?.list.filter((x) => x.isUnderMaintenance == true);
        this.getMyCompanyDetails(); // get total meeting room count
        console.log(this.totalMeetingRoomCount);
      } else {
        this.MeetingRoomList = [];
        this.MeetingRoomListUnderMaintaince = [];
      }
    });
    console.log(this.MeetingRoomList);
    this.isLoaded = true
  }

  selectType(type) {
    console.log(type.target.value)
    this.type = type.target.value;
    if (type.target.value == 'act') {
      this.actProp = true;
      this.underMaintainance = false;
    } else {
      this.actProp = false;
      this.underMaintainance = true;
    }
  }

  openDrawer(id, item) {
    $('#' + id).find('.drawer-container').toggle();
  }

  open(content) {
    this.modalService
      .open(content, {
        ariaLabelledBy: 'modal-basic-title',
        centered: true,
        windowClass: 'custom-class',
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }


  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  openModal(id, roomname) {
    this.open(this.content);
    this.MeetingRoomId = id;
    this.meetingRoomName = roomname;
  }

  DeleteMeetingRoom() {
    this.deleteMeetingRoomMethod(this.MeetingRoomId, this.meetingRoomName);
  }

  deleteMeetingRoomMethod(meetingRoomId, meetingRoomName) {
    localStorage.setItem("viewMeetingRoomName", meetingRoomName);
    const body = {
      parkMeetingRoomId: meetingRoomId
    }
    this.meetingService.deleteParkMeetingRoom(body).subscribe((res) => {
      if (res.isValid) {
        const paymentStatus = 'free';
        this.getMeetingRoomByPark(this.ParkId, paymentStatus);
      } else {
        this.route.navigate(['company/details-meeting-room'], {
          queryParams: { id: meetingRoomId, taId: this.taId },
        });
      }
    });
  }

  navigateToEdit(id) {
    this.route.navigate(['company/edit-meeting-room'], {
      queryParams: { meetingRoomId: id },
    });
  }


  onClickedOutside(e: Event) {
    // console.log('Clicked outside:', e);
  }

  openPopover(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  goToDetailsPage(parkMeetingRoomId) {
    if (parkMeetingRoomId != null) {
      this.route.navigate(['/company/details-meeting-room'], {
        queryParams: { id: parkMeetingRoomId, taId: this.taId },
      });
    }
  }


  getMyCompanyDetails() {
    const parkTenantId = localStorage.getItem('tenantAdminId');
    const parkId = localStorage.getItem('parkId');
    this.meetingService.getMyCompanyDetails(parkTenantId, parkId).subscribe(
      (response: any) => {
        if (response.isValid && response.data != null) {
          console.log(response.data.employees);
          this.maxConferenceRoom = response?.data.maxConferenceRoom ?? 0;
          this.totalMeetingRoomCount = response?.data.totalMeetingRoomCount ?? 0;
          localStorage.setItem('totalMeetingRoomCount', this.totalMeetingRoomCount);
          localStorage.setItem('maxConferenceRoom', this.maxConferenceRoom);
        }
      }
    );
  }
}